import { jsx, jsxs } from 'react/jsx-runtime';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { Row } from '../../Row/index.js';
import { SelectButtonWithValidation } from '../Items/SelectBox.js';
import { ArrowIcon } from '../Items/ArrowIcon.js';

const borderlessStyles = `
  color: ${ndsTokens.colors.text.onLight.primary};
`;
const LabelSpan = styled.span`
  padding-right: ${ndsTokens.space.generic.x1};
  ${props => props.boldLabel ? 'font-weight: bold;' : ''}
  ${props => props.hasStrikethrough ? 'text-decoration: line-through;' : ''}
`;
const ValueSpan = styled.span`
  ${props => props.boldValue ? 'font-weight: bold' : ''};
  ${props => props.hasStrikethrough ? 'text-decoration: line-through;' : ''}
`;
const StyledText = styled.span`
  overflow: hidden;
  ${props => props.variant === 'borderless' && borderlessStyles}
`;
const StyledIcon = styled.span`
  margin-left: ${ndsTokens.space.inset.x2};
  display: flex;
  align-items: center;

  svg {
    path {
      fill: currentColor;
    }
  }
`;

const DefaultDisplayLabel = ({
  label,
  value,
  disabled,
  size,
  valid,
  invalid,
  display,
  variant = 'secondary',
  boldValue,
  boldLabel,
  hasStrikethrough,
  valueRenderer,
  ...restProps
}) => jsx(SelectButtonWithValidation, Object.assign({
  "aria-hidden": true,
  disabled: disabled,
  display: display,
  size: size,
  styleProps: {
    valid,
    invalid
  },
  tabIndex: "-1",
  variant: variant === 'borderless' ? 'blank' : variant
}, restProps, {
  children: jsxs(Row, Object.assign({
    between: "xs",
    className: "select--customLabel",
    middle: "xs"
  }, {
    children: [jsxs(StyledText, Object.assign({
      variant: variant
    }, {
      children: [label && jsx(LabelSpan, Object.assign({
        boldLabel: boldLabel,
        hasStrikethrough: hasStrikethrough
      }, {
        children: label
      }), void 0), value && !valueRenderer ? jsx(ValueSpan, Object.assign({
        boldValue: boldValue,
        hasStrikethrough: hasStrikethrough
      }, {
        children: value
      }), void 0) : valueRenderer]
    }), void 0), jsx(StyledIcon, {
      children: jsx(ArrowIcon, {
        fillColor: variant === 'primary' ? ndsTokens.colors.palette.white : ndsTokens.colors.iconFill.onLight,
        size: size
      }, void 0)
    }, void 0)]
  }), void 0)
}), void 0);

DefaultDisplayLabel.displayName = 'DefaultDisplayLabel';
var DefaultDisplayLabel$1 = styled(DefaultDisplayLabel)`
  pointer-events: none;
`;

export { DefaultDisplayLabel$1 as default };
